
interface ReviewerInterface {
  _id: string;
  fullName: string;
  profileImage: string;
  email: string   
}

export interface ReviewInterface {
  id: string;
  gig: string; // Gig ID
  reviewer: ReviewerInterface; 
  order: string;
  rating: number;
  attachments?: string[];
  comment: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export class Review implements ReviewInterface {
  id: string;
  gig: string;
  reviewer: ReviewerInterface;
  order: string;
  rating: number;
  attachments?: string[];
  comment: string;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(jsonData: any) {
    this.id = jsonData._id;
    this.gig = jsonData.gig;
    this.reviewer = jsonData.reviewer;
    this.order = jsonData.order;
    this.rating = jsonData.rating;
    this.attachments = Array.isArray(jsonData?.attachments)
      ? jsonData.attachments.filter((url: unknown): url is string => typeof url === 'string')
      : [];
    this.comment = jsonData.comment;
    this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
    this.updatedAt = jsonData.updatedAt ? new Date(jsonData.updatedAt) : undefined;
  }
}
